import React from 'react';

import { Icon, Text } from '../../../../components';
import { Root } from './PulseBadge.styles';

export type PulseBadgeProps = {
  /** Pill copy — a data value (passed through `<Text>`). */
  text: string;
  /** Render the down (red) variant with a down trend arrow. */
  down?: boolean;
};

/**
 * Small trend pill used throughout the Pulse page (deltas, rank change, metric
 * badges). Green "up" by default; `down` flips it red. The arrow inherits the
 * pill's `color` via `currentColor`.
 */
export const PulseBadge = ({ text, down = false }: PulseBadgeProps): React.ReactElement => (
  <Root $down={down}>
    <Icon name={down ? 'trending-down' : 'trending-up'} size={10} />
    <Text text={text} tag="span" />
  </Root>
);

export default PulseBadge;
